import { useState } from "react";
import { Collapse, Nav } from "react-bootstrap";

// Icons
import { FaStore } from "react-icons/fa6";
import { ImPageBreak } from "react-icons/im";
import { LuTicketSlash } from "react-icons/lu";
import { PiChatsDuotone } from "react-icons/pi";
import { MdOutlinePostAdd } from "react-icons/md";
import { SiPagespeedinsights } from "react-icons/si";
import { IoCubeOutline, IoExtensionPuzzleOutline } from "react-icons/io5";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

// Pages
import OverviewData from "./OverviewData";
import ChatWidgetData from "./WidgetSettings/ChatWidgetData";
import PageData from "./PageSettings/PageData";
import BlogPage from "./BlogPostManagement/BlogPage/BlogPage";
import StoreManagement from "./StoreManagement/StoreManagement";
import Integration from "./Integration/Integration";
import Addons from "./Addons/Addons";
import TwilioSMSSettings from "./Integration/IntegrationSettings/TwilioSMSSettings";
import WooCommerceSettings from "./Integration/IntegrationSettings/WooCommerceSettings";

/* Example Integration Sub Pages */
const SettingsData = ({ getCurrectLoginUser, currentUserData }) => {
  const [openModule, setOpenModule] = useState("overview");
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const menuItems = [
    { key: "overview", label: "Overview", icon: <SiPagespeedinsights /> },
    { key: "chatWidget", label: "Chat Widget", icon: <PiChatsDuotone /> },
    { key: "ticketing", label: "Ticketing", icon: <LuTicketSlash /> },
    { key: "pages", label: "Pages", icon: <ImPageBreak /> },

    ...(currentUserData?.blogPage
      ? [{ key: "blockPage", label: "Blog Page", icon: <MdOutlinePostAdd /> }]
      : []),

    { key: "store", label: "Store", icon: <FaStore /> },

    {
      key: "integrations",
      label: "Integrations",
      icon: <IoExtensionPuzzleOutline />,
      children: [
        { key: "twilio_sms", label: "Twilio SMS" },
        { key: "woo_commerce", label: "WooCommerce" },
      ],
    },

    { key: "addons", label: "Add-ons", icon: <IoCubeOutline /> },
  ];

  return (
    <div className="w-100 hstack">
      {/* SIDEBAR */}
      <div
        style={{ height: "calc(100vh - 56px)", minWidth: 250 }}
        className="overflow-auto border-end"
      >
        <div className="p-3 pb-0">
          <h6>Administration</h6>
        </div>

        <Nav className="flex-column p-2 gap-1">
          {menuItems.map((item) => {
            const hasChildren = item?.children?.length > 0;
            const isOpen = openSubmenu === item?.key;
            const isActive = openModule === item?.key;

            return (
              <div key={item?.key}>
                <Nav.Link
                  className={`sidebar-link d-flex align-items-center justify-content-between ${(isActive || isOpen) ? "active" : ""}`}
                  onClick={() => {
                    if (hasChildren) {
                      setOpenSubmenu(isOpen ? null : item?.key);
                      setOpenModule(item?.key);
                    } else {
                      setOpenModule(item?.key);
                      setOpenSubmenu(null);
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ fontSize: 14 }}>{item?.icon}</span>
                    <span style={{ fontSize: 14 }}>{item?.label}</span>
                  </div>

                  {hasChildren &&
                    (isOpen ? <FiChevronUp /> : <FiChevronDown />)}
                </Nav.Link>

                {/* SUB MENU */}
                {hasChildren && (
                  <Collapse in={openSubmenu}>
                    <div className="ms-4">
                      {item?.children.map((child) => (
                        <Nav.Link
                          key={child?.key}
                          style={{ fontSize: 14 }}
                          onClick={() => setOpenModule(child?.key)}
                          className={`sidebar-link mt-1 ${openModule === child?.key ? "active" : ""}`}
                        >
                          {child?.label}
                        </Nav.Link>
                      ))}
                    </div>
                  </Collapse>
                )}
              </div>
            );
          })}
        </Nav>
      </div>

      {/* CONTENT */}
      <div
        className="w-100 bg-light overflow-auto"
        style={{ height: "calc(100vh - 56px)" }}
      >
        {openModule === "overview" && (
          <OverviewData
            getCurrectLoginUser={getCurrectLoginUser}
            currentUserData={currentUserData}
          />
        )}

        {openModule === "chatWidget" && <ChatWidgetData />}
        {openModule === "pages" && (
          <PageData getCurrectLoginUser={getCurrectLoginUser} />
        )}
        {openModule === "blockPage" && <BlogPage />}
        {openModule === "store" && <StoreManagement />}
        {openModule === "integrations" && <Integration />}
        {openModule === "addons" && <Addons />}

        {/* Integration Sub Pages */}
        {openModule === "twilio_sms" && <TwilioSMSSettings />}
        {openModule === "woo_commerce" && <WooCommerceSettings />}
      </div>
    </div>
  );
};

export default SettingsData;
